<template>
  <a-card title="近30天交易情况统计">
    <div id="transactionRecentlyMyEcharts" style="height: 400px"></div>
  </a-card>
</template>

<script>
import { onMounted, ref, inject, onUnmounted } from "vue";
import { payOrderRecently } from "@/api/dashboardApi";
import useMessage from "@/hooks/useMessage";
import useDashboard from "@/hooks/useDashboard";

export default {
  name: "LeftTransactionRecently",
  setup() {
    const loading = ref(false);
    const { showErr } = useMessage();
    const { money } = useDashboard();
    const echarts = inject("ec");
    let transactionRecentlyMyEcharts = ref(null);
    onMounted(async () => {
      transactionRecentlyMyEcharts.value = echarts.init(
        document.getElementById("transactionRecentlyMyEcharts"),
      );
      transactionRecentlyMyEcharts.value.setOption(options());
      loadData();
      window.onresize = () => {
        transactionRecentlyMyEcharts.value.resize();
      };
    });
    onUnmounted(() => {
      transactionRecentlyMyEcharts.value.dispose();
      transactionRecentlyMyEcharts.value = null;
    });
    const options = () => {
      return {
        title: {
          // text: "24小时停车",
          textStyle: {
            // 文字颜色
            color: "rgb(3, 153, 204)",
            // 字体风格,'normal','italic','oblique'
            fontStyle: "normal",
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: "bold",
            // 字体系列
            fontFamily: "sans-serif",
            // 字体大小
            fontSize: 18,
          },
        },
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        color: ["#1E90FF", "#32CD32"],
        legend: {
          x: "right",
          data: [
            {
              name: "交易金额(元)",
              textStyle: {
                color: "#1E90FF",
              },
            },
            {
              name: "交易笔数(笔)",
              textStyle: {
                color: "#32CD32",
              },
            },
          ],
          textStyle: {
            color: "white",
            fontSize: 14,
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgb(0, 204, 255)", // 横坐标线的颜色
            },
          },
          axisLabel: {
            textStyle: {
              // color: "white", // 横坐标字体颜色
            },
          },
          axisTick: {
            interval: 1,
          },
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
          splitLine: {
            // 分隔线
            // show: false,
          },
          axisLine: {
            lineStyle: {
              color: "rgb(0, 204, 255)", // 纵坐标线的颜色
            },
          },
        },
        series: [],
      };
    };
    const setOptions = (orderNumberList, orderAmountList, xData) => {
      let amountRecord = {
        name: "交易金额(元)",
        type: "bar",
        data: orderAmountList,
      };
      let numberRecord = {
        name: "交易笔数(笔)",
        type: "line",
        data: orderNumberList,
      };
      let option = {
        series: [amountRecord, numberRecord],
        xAxis: {
          data: xData.sort((a, b) => {
            return b < a ? 1 : -1; // 升序
          }),
        },
      };
      transactionRecentlyMyEcharts.value.setOption(option);
    };
    const loadData = async () => {
      loading.value = true;
      try {
        let r = await payOrderRecently();
        let xData = [];
        let orderNumberList = [];
        let orderAmountList = [];
        r.data.forEach(item => {
          xData.push(item.date);
          let p1 = {
            name: item.date,
            value: item.orderNumber,
          };
          let p2 = {
            name: item.date,
            value: money(item.orderAmount),
          };
          orderNumberList.push(p1);
          orderAmountList.push(p2);

          orderNumberList.sort((a,b)=>{
            return a.name > b.name ? 1 : -1
          })
          orderAmountList.sort((a,b)=>{
            return a.name > b.name ? 1 : -1
          })
          setOptions(orderNumberList, orderAmountList, xData);
        });

        loading.value = false;
      } catch (e) {
        loading.value = false;
        showErr(e);
      }
    };

    return {
      echarts,
      options,
      loading,
      loadData,
      setOptions,
      money,
      transactionRecentlyMyEcharts,
    };
  },
};
</script>
